import React, { useContext, useEffect, useMemo } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import OrderStepFrame from '../../Components/OrderStep/OrderStepFrame';
import OrderStep_1 from '../../Components/OrderStep/OrderStep_1';
import OrderStep_2 from '../../Components/OrderStep/OrderStep_2';
import OrderStep_3 from '../../Components/OrderStep/OrderStep_3';
import OrderStep_3_mealInfo from '../../Components/OrderStep/OrderStep_3_mealInfo';
import OrderStep_4 from '../../Components/OrderStep/OrderStep_4';
import OrderStep_5 from '../../Components/OrderStep/OrderStep_5';
import OrderStep_5_verifyEmail from '../../Components/OrderStep/OrderStep_5_verifyEmail';
import { Global } from '../../App';
import moment from 'moment';
import qs from 'querystring';
import '../pages.scss';

// switch lang
import { countryCodeToCode, langCodeToString } from '../../Share/Tools/switchLang';
// api
import { postQRCodeVerifyQueue } from '../../Api/VerifyQueue';

function TakeOrder(props) {
  const { globalState, dispatchGlobal } = useContext(Global);

  // 檢查get參數
  const checkURL = useMemo(() => {
    const { search } = props.location;
    if (search !== '' && search !== undefined && search !== null) {
      const par = qs.parse(search.split('?')[1]);
      return par;
    } else {
      return '';
    }
  }, [props.location.search]);

  // 驗證來店資訊
  async function apiVerifyQRCode() {
    const par = checkURL;
    try {
      const res = await postQRCodeVerifyQueue({
        queueNumber: par.queueNumber,
        queueCode: par.queueCode,
        storeID: par.storeID
      });
      console.log('qrcode yes')
      const { errCode } = res.data;
      const { orderCode } = res.data.response
      if (res && ((errCode == 200 || errCode == 420 || errCode == 4201) || orderCode !== null)) {
        return res;
      } else {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: errCode }]
        });
        props.history.replace('/error');
      }
    } catch (err) {
      console.error('QRCodeVerifyQueue error.');
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'errMsg', val: 405 }]
      });
      props.history.push('/error');
    }
  }
  // 檢查是否有get參數(由QRcode進入網站)
  async function handler() {
    const par = checkURL;
    if (par) {
      let verifyQRCode = await apiVerifyQRCode();
      if (verifyQRCode) {
        const {
          verify,
          childCount,
          adultsCount,
          countryID,
          countryName,
          storeID,
          storeName,
          orderCode,
          createAt,
          languageID,
          posStatus,
          posCode,
          tableNo,
          mainOrderCode
        } = verifyQRCode.data.response;
        if (orderCode !== null) {
          // 2022-06-24 流程+判斷能否加點 flower
          if (posStatus) {
            dispatchGlobal({
              type: 'UPDATE',
              payload: [
                { key: 'ordermode', val: 'addorder' },
                // 在這裡判斷 回傳的 countryID 需要遷換成哪種語言
                { key: 'langType', val: langCodeToString(languageID) },
                {
                  key: 'customer',
                  val: {
                    isReady: true,
                    currentStep: '3',
                    mealDetail: '',
                    mealOrderDetail: [],
                    orderInfo: {
                      ...globalState.customer.orderInfo,
                      posCode: posCode,
                      tableNo: (tableNo ? tableNo : ""),
                      mainOrderCode: mainOrderCode,
                      country: countryID,
                      countryName: countryName,
                      queueNumber: par.queueNumber,
                      queueCode: par.queueCode,
                      numberOfAdult: adultsCount,
                      numberOfChild: childCount,
                      tempOrderCode: "",
                      tempOrderGroupID: "",
                      tempOrderID: "",
                      orderTime: moment().format('YYYY/MM/DD hh:mm:ss'),
                      selectedBranch: {
                        branchCode: storeID,
                        branchName: storeName
                      }
                    },
                    orderDetail: {
                      totalMealQuantity: 0,
                      dineInTotalPrice: 0,
                      dineInSpecPrice: 0,
                      takeoutInTotalPrice: 0,
                      takeoutInSpecPrice: 0
                    }
                  }
                }
              ]
            });
          }
          else {
            props.history.push(`/showOrderDetail?orderCode=${orderCode}&storeID=${String(storeID)}&createAt=${createAt}`);
          }
        } else {
          // 新單(無餐點在內或與暫存不同張單)
          if (globalState.customer.mealOrderDetail.length === 0 || (
            par.queueNumber !== globalState.customer.orderInfo.queueNumber &&
            par.queueCode !== globalState.customer.orderInfo.queueCode) ||
            moment().format('YYYY/MM/DD') !== globalState.customer.orderInfo.orderTime.slice(0, 10)) {
            dispatchGlobal({
              type: 'UPDATE',
              payload: [
                // 在這裡判斷 回傳的 countryID 需要遷換成哪種語言
                { key: 'langType', val: langCodeToString(languageID) },
                {
                  key: 'customer',
                  val: {
                    isReady: true,
                    currentStep: '2',
                    mealDetail: '',
                    mealOrderDetail: [],
                    orderInfo: {
                      ...globalState.customer.orderInfo,
                      country: countryID,
                      countryName: countryName,
                      queueNumber: par.queueNumber,
                      queueCode: par.queueCode,
                      numberOfAdult: adultsCount,
                      numberOfChild: childCount,
                      orderTime: moment().format('YYYY/MM/DD hh:mm:ss'),
                      selectedBranch: {
                        branchCode: storeID,
                        branchName: storeName
                      }
                    },
                    orderDetail: {
                      totalMealQuantity: 0,
                      dineInTotalPrice: 0,
                      dineInSpecPrice: 0,
                      takeoutInTotalPrice: 0,
                      takeoutInSpecPrice: 0
                    }
                  }
                }
              ]
            });
          } else {
            dispatchGlobal({
              type: 'UPDATE',
              payload: [
                {
                  key: 'customer',
                  val: {
                    isReady: true,
                    currentStep: globalState.customer.currentStep,
                    mealDetail: globalState.customer.mealDetail,
                    mealOrderDetail: [
                      ...globalState.customer.mealOrderDetail
                    ],
                    orderInfo: {
                      ...globalState.customer.orderInfo,
                      country: countryID,
                      countryName: countryName,
                      queueNumber: par.queueNumber,
                      queueCode: par.queueCode,
                      numberOfAdult: adultsCount,
                      numberOfChild: childCount,
                      orderTime: moment().format('YYYY/MM/DD hh:mm:ss'),
                      selectedBranch: {
                        branchCode: storeID,
                        branchName: storeName
                      }
                    },
                    orderDetail: {
                      ...globalState.customer.orderDetail
                    }
                  }
                }
              ]
            });
          }
        }

        // 驗證成功導向 => QRCodeSuccess
        // props.history.replace('/QRCodeSuccess');
      }
    } else {
      dispatchGlobal({
        type: 'UPDATE',
        payload: [
          {
            key: 'customer',
            val: {
              ...globalState.customer,
              isReady: true
            }
          }
        ]
      });
    }
  }
  // render step
  const renderStep = useMemo(() => {
    const step = globalState.customer.currentStep;
    console.log("step", step);
    switch (step) {
      case '1':
        return (
          <>
            <Header />
            <OrderStepFrame>
              <OrderStep_1 />
            </OrderStepFrame>
            <Footer />
          </>
        );
      case '2':
        return (
          <>
            <Header />
            <OrderStepFrame>
              <OrderStep_2 />
            </OrderStepFrame>
            <Footer />
          </>
        );
      case '3':
        return (
          <>
            <Header />
            <OrderStepFrame>
              <OrderStep_3 />
            </OrderStepFrame>
            <Footer />
          </>
        );
      case '3.1':
        return (
          <>
            <Header />
            <OrderStep_3_mealInfo />
            <Footer />
          </>
        );
      case '4':
        return (
          <>
            <Header />
            <OrderStepFrame>
              <OrderStep_4 />
            </OrderStepFrame>
            <Footer />
          </>
        );
      case '5':
        return (
          <>
            <Header />
            <OrderStepFrame>
              <OrderStep_5 />
            </OrderStepFrame>
            <Footer />
          </>
        );
      case '5.1':
        return (
          <>
            <Header />
            <OrderStep_5_verifyEmail />
            <Footer />
          </>
        );
      case 'null':
        return null;
      default:
        throw Error('step page error.');
    }
  }, [globalState.customer.currentStep]);

  useEffect(() => {
    handler();
  }, [globalState.customer.isReady, props.location.search]);

  useEffect(() => {
    window.document.body.scrollTop = 0;
    if (globalState.customer.currentStep === '1') {
      dispatchGlobal({
        type: 'UPDATE',
        payload: [{ key: 'ordermode', val: 'order' }]
      });
    }
  }, [globalState.customer.currentStep])



  if (!globalState.customer.isReady) {
    return null;
  } else {
    return <div className="Pages">{renderStep}</div>;
  }
}
export default TakeOrder;
